import {
  useEffect,
  useState
} from "react";

import {
  useNavigate
} from "react-router-dom";

import Select from "react-select";

import API from "../../services/api";

function AddSalesReturn() {

  const navigate =
    useNavigate();

  const [loadingInvoice,
    setLoadingInvoice] =
    useState(false);

  const [refundType,
    setRefundType] =
    useState("wallet");

  const [customers,
    setCustomers] =
    useState([]);

  const [wallets,
    setWallets] =
    useState([]);

  const [products,
    setProducts] =
    useState([]);

  const [invoices, setInvoices] = useState([]);

  const [items,
    setItems] =
    useState([]);

  const [form,
    setForm] =
    useState({

      customer_id: "",

      invoice_id: "",

      wallet_id: "",

      return_date:
        new Date()
          .toISOString()
          .slice(0, 10),

      reason: ""

    });

  useEffect(() => {

    loadData();

  }, []);

  const loadData =
    async () => {

      try {

        const [
          customersRes,
          walletsRes,
          invoicesRes,
          productsRes
        ] = await Promise.all([

          API.get("/customers"),

          API.get("/wallets"),

          API.get("/invoices"),

          API.get("/products")

        ]);

        console.log(invoicesRes.data, "data");

        setCustomers(
          customersRes.data.customers || []
        );

        setWallets(
          walletsRes.data.wallets || []
        );

        setInvoices(
          invoicesRes.data.invoices || []
        );

        setProducts(
          productsRes.data.products || []
        );

      } catch (err) {

        console.log(err);

      }

    };

  /*
  =====================================
  LOAD INVOICE PRODUCTS
  =====================================
  */

  const loadInvoiceItems =
    async (invoiceId) => {

      if (!invoiceId) {

        setItems([]);

        setForm(prev => ({

          ...prev,

          invoice_id: "",

          customer_id: "",

          wallet_id: ""

        }));

        return;

      }

      try {

        setLoadingInvoice(true);

        const res =
          await API.get(
            `/sales-returns/${invoiceId}/return-items`
          );

        const {

          invoice,

          products

        } = res.data;

        setForm(prev => ({

          ...prev,

          invoice_id:
            invoice.id,

          customer_id:
            invoice.customer_id,

          wallet_id:
            invoice.wallet_id

        }));

        setItems(

          products.map(product => ({

            product_id:
              product.product_id,

            product_name:
              product.name,

            sold_qty:
              product.sold_qty,

            returned_qty:
              product.returned_qty,

            available_qty:
              product.available_qty,

            qty: 1,

            price:
              product.selling_price,

            gst_percent:
              product.gst_percent

          }))

        );

      } catch (err) {

        console.log(err);

      } finally {

        setLoadingInvoice(false);

      }

    };

  /*
  =====================================
  TOTALS
  =====================================
  */

  const subtotal =
    items.reduce(

      (sum, item) =>

        sum +

        (

          Number(item.qty) *

          Number(item.price)

        ),

      0

    );

  const gstTotal =
    items.reduce(

      (sum, item) => {

        const amount =

          Number(item.qty) *

          Number(item.price);

        return (

          sum +

          (

            amount *

            Number(item.gst_percent)

          ) / 100

        );

      },

      0

    );

  const grandTotal =
    subtotal +
    gstTotal;

      /*
  =====================================
  UPDATE PRODUCT ROW
  =====================================
  */

  const updateItem = (
    index,
    field,
    value
  ) => {

    const temp =
      [...items];

    temp[index][field] =
      value;

    /*
    Qty Validation
    */

    if (
      field === "qty"
    ) {

      let qty =
        Number(value);

      if (qty < 1) {

        qty = 1;

      }

      if (
        qty >
        Number(
          temp[index]
            .available_qty
        )
      ) {

        alert(

          `Maximum return quantity is ${temp[index].available_qty}`

        );

        qty =
          Number(
            temp[index]
              .available_qty
          );

      }

      temp[index].qty =
        qty;

    }

    setItems(temp);

  };

  /*
  =====================================
  REMOVE PRODUCT
  =====================================
  */

  const removeRow =
    (index) => {

      const temp =
        [...items];

      temp.splice(
        index,
        1
      );

      setItems(temp);

    };

  /*
  =====================================
  ADD ROW
  =====================================
  */

  const addRow =
    () => {

      setItems([

        ...items,

        {

          product_id: "",

          product_name: "",

          qty: 1,

          price: 0,

          gst_percent: 0,

          sold_qty: 0,

          returned_qty: 0,

          available_qty: 0

        }

      ]);

    };

  /*
  =====================================
  SUBMIT
  =====================================
  */

  const submit =
    async (e) => {

      e.preventDefault();

      /*
      Invoice Required
      */

      if (
        !form.invoice_id
      ) {

        return alert(
          "Please select invoice."
        );

      }

      /*
      Wallet Required
      */

      if (

        refundType === "wallet"

        &&

        !form.wallet_id

      ) {

        return alert(
          "Please select refund wallet."
        );

      }

      /*
      Products
      */

      if (

        items.length === 0

      ) {

        return alert(
          "Please add products."
        );

      }

      /*
      Reason
      */

      if (

        !form.reason.trim()

      ) {

        return alert(
          "Please enter return reason."
        );

      }

      /*
      Qty Validation
      */

      const invalid =
        items.find(

          item =>

            Number(item.qty)

            >

            Number(
              item.available_qty
            )

        );

      if (invalid) {

        return alert(

          `${invalid.product_name} exceeds available quantity.`

        );

      }

      try {

        await API.post(

          "/sales-returns",

          {

            ...form,

            refund_type:
              refundType,

            subtotal,

            gst_total:
              gstTotal,

            grand_total:
              grandTotal,

            items

          }

        );

        alert(
          "Sales Return Created Successfully."
        );

        navigate(
          "/admin/sales-returns"
        );

      } catch (err) {

        console.log(err);

        alert(

          err.response?.data?.message ||

          "Something went wrong."

        );

      }

    };

      return (

    <div>

      <div
        className="
        flex
        justify-between
        items-center
        mb-8
        flex-wrap
        gap-4
        "
      >

        <h1
          className="
          text-4xl
          font-bold
          "
        >
          Add Sales Return
        </h1>

        <button
          onClick={() =>
            navigate(
              "/admin/sales-returns"
            )
          }
          className="
          bg-gray-700
          px-6
          py-3
          rounded-xl
          "
        >
          Back
        </button>

      </div>

      <form
        onSubmit={submit}
        className="
        bg-[#111]
        rounded-2xl
        p-6
        "
      >

        <div
          className="
          grid
          md:grid-cols-2
          gap-5
          "
        >

          {/* Invoice */}

          <div>

            <label
              className="
              block
              mb-2
              "
            >
              Invoice
            </label>

            <Select
            className="text-dark"

              options={

                invoices.map(

                  invoice => ({

                    value:
                      invoice.id,

                    label:
                      `${invoice.invoice_no} - ${invoice.customer_name}`

                  })

                )

              }

              value={

                invoices
                  .map(invoice => ({

                    value:
                      invoice.id,

                    label:
                      `${invoice.invoice_no} - ${invoice.customer_name}`

                  }))

                  .find(

                    option =>

                      option.value ===
                      form.invoice_id

                  )

              }

              onChange={(selected)=>{

                const invoiceId =

                  selected
                    ? selected.value
                    : "";

                loadInvoiceItems(
                  invoiceId
                );

              }}

            />

          </div>

          {/* Customer */}

          <div>

            <label
              className="
              block
              mb-2
              "
            >
              Customer
            </label>

            <Select
            className="text-dark"

              isDisabled

              options={

                customers.map(

                  customer => ({

                    value:
                      customer.id,

                    label:
                      customer.customer_name

                  })

                )

              }

              value={

                customers
                  .map(customer => ({

                    value:
                      customer.id,

                    label:
                      customer.customer_name

                  }))

                  .find(

                    option =>

                      option.value ===
                      form.customer_id

                  )

              }

            />

          </div>

          {/* Wallet */}

          <div>

            <label
              className="
              block
              mb-2
              "
            >
              Refund Wallet
            </label>

            <Select
            className="text-dark"

              isDisabled={
                refundType !==
                "wallet"
              }

              options={

                wallets.map(

                  wallet => ({

                    value:
                      wallet.id,

                    label:
                      wallet.wallet_name

                  })

                )

              }

              value={

                wallets
                  .map(wallet => ({

                    value:
                      wallet.id,

                    label:
                      wallet.wallet_name

                  }))

                  .find(

                    option =>

                      option.value ===
                      form.wallet_id

                  )

              }

              onChange={(selected)=>

                setForm({

                  ...form,

                  wallet_id:

                    selected
                      ? selected.value
                      : ""

                })

              }

            />

          </div>

          {/* Return Date */}

          <div>

            <label
              className="
              block
              mb-2
              "
            >
              Return Date
            </label>

            <input

              type="date"

              value={
                form.return_date
              }

              onChange={(e)=>

                setForm({

                  ...form,

                  return_date:
                    e.target.value

                })

              }

              className="
              w-full
              p-3
              rounded-xl
              bg-black
              border
              border-yellow-500/20
              "

            />

          </div>

        </div>

        {/* Refund Type */}

        <div
          className="
          mt-8
          "
        >

          <label
            className="
            block
            mb-4
            font-semibold
            "
          >
            Refund Type
          </label>

          <div
            className="
            grid
            md:grid-cols-2
            gap-5
            "
          >

            <div

              onClick={()=>
                setRefundType(
                  "wallet"
                )
              }

              className={`
              cursor-pointer
              rounded-2xl
              border
              p-6
              transition

              ${
                refundType==="wallet"

                ?

                "border-green-500 bg-green-500/10"

                :

                "border-gray-700"

              }

              `}
            >

              <h3
                className="
                text-xl
                font-bold
                "
              >
                💰 Wallet Refund
              </h3>

              <p
                className="
                text-gray-400
                mt-2
                "
              >
                Refund amount
                will be deducted
                from selected wallet.
              </p>

            </div>

            <div

              onClick={()=>
                setRefundType(
                  "adjust"
                )
              }

              className={`
              cursor-pointer
              rounded-2xl
              border
              p-6
              transition

              ${
                refundType==="adjust"

                ?

                "border-blue-500 bg-blue-500/10"

                :

                "border-gray-700"

              }

              `}
            >

              <h3
                className="
                text-xl
                font-bold
                "
              >
                🧾 Adjust Against Due
              </h3>

              <p
                className="
                text-gray-400
                mt-2
                "
              >
                Reduce customer's
                remaining invoice due.
              </p>

            </div>

          </div>

        </div>

        {/* Reason */}

        <div
          className="
          mt-8
          "
        >

          <label
            className="
            block
            mb-2
            "
          >
            Return Reason
          </label>

          <textarea

            rows="4"

            value={
              form.reason
            }

            onChange={(e)=>

              setForm({

                ...form,

                reason:
                  e.target.value

              })

            }

            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            "

          />

        </div>

        {loadingInvoice && (

          <div
            className="
            mt-6
            p-4
            rounded-xl
            bg-blue-500/10
            text-blue-400
            "
          >

            Loading invoice products...

          </div>

        )}

                {/* =========================
            PRODUCTS TABLE
        ========================= */}

        <div className="mt-8">

          <div className="flex justify-between items-center mb-4">

            <h2 className="text-2xl font-bold">
              Return Products
            </h2>

            {
              !form.invoice_id && (

                <button
                  type="button"
                  onClick={addRow}
                  className="
                  bg-yellow-500
                  text-black
                  px-5
                  py-2
                  rounded-xl
                  font-semibold
                  "
                >
                  + Add Product
                </button>

              )
            }

          </div>

          <div className="overflow-x-auto">

            <table
              className="
              w-full
              border
              border-yellow-500/20
              "
            >

              <thead>

                <tr
                  className="
                  bg-yellow-500
                  text-black
                  "
                >

                  <th className="p-3">
                    Product
                  </th>

                  <th className="p-3">
                    Sold
                  </th>

                  <th className="p-3">
                    Returned
                  </th>

                  <th className="p-3">
                    Available
                  </th>

                  <th className="p-3">
                    Return Qty
                  </th>

                  <th className="p-3">
                    Price
                  </th>

                  <th className="p-3">
                    GST %
                  </th>

                  <th className="p-3">
                    Amount
                  </th>

                  <th className="p-3">
                    Action
                  </th>

                </tr>

              </thead>

              <tbody>

                {

                  items.map(

                    (item, index) => (

                      <tr
                        key={index}
                        className="
                        border-t
                        border-yellow-500/10
                        "
                      >

                        {/* PRODUCT */}

                        <td className="p-3 min-w-[250px]">

                          <Select
                          className="text-dark"

                            isDisabled={
                              !!form.invoice_id
                            }

                            options={

                              form.invoice_id

                                ?

                                items.map(p => ({

                                  value:
                                    p.product_id,

                                  label:
                                    p.product_name

                                }))

                                :

                                products.map(product => ({

                                  value:
                                    product.id,

                                  label:
                                    `${product.name} (Stock : ${product.stock})`

                                }))

                            }

                            value={

                              item.product_id

                                ?

                                {

                                  value:
                                    item.product_id,

                                  label:
                                    item.product_name

                                }

                                :

                                null

                            }

                            onChange={(selected)=>{

                              const product =
                                products.find(

                                  p=>

                                    p.id===selected.value

                                );

                              updateItem(

                                index,

                                "product_id",

                                product.id

                              );

                              updateItem(

                                index,

                                "product_name",

                                product.name

                              );

                              updateItem(

                                index,

                                "price",

                                product.selling_price

                              );

                              updateItem(

                                index,

                                "gst_percent",

                                product.gst_percent

                              );

                              updateItem(

                                index,

                                "available_qty",

                                product.stock

                              );

                            }}

                          />

                        </td>

                        {/* SOLD */}

                        <td className="p-3 text-center">

                          {item.sold_qty || "-"}

                        </td>

                        {/* RETURNED */}

                        <td className="p-3 text-center">

                          {item.returned_qty || 0}

                        </td>

                        {/* AVAILABLE */}

                        <td
                          className="
                          p-3
                          text-center
                          text-green-400
                          font-semibold
                          "
                        >

                          {item.available_qty || "-"}

                        </td>

                        {/* QTY */}

                        <td className="p-3">

                          <input

                            type="number"

                            min="1"

                            max={item.available_qty}

                            value={item.qty}

                            onChange={(e)=>

                              updateItem(

                                index,

                                "qty",

                                e.target.value

                              )

                            }

                            className="
                            w-24
                            p-2
                            rounded-lg
                            bg-black
                            border
                            border-yellow-500/20
                            text-center
                            "

                          />

                        </td>

                        {/* PRICE */}

                        <td className="p-3">

                          <input

                            type="number"

                            disabled={
                              !!form.invoice_id
                            }

                            value={item.price}

                            onChange={(e)=>

                              updateItem(

                                index,

                                "price",

                                e.target.value

                              )

                            }

                            className="
                            w-28
                            p-2
                            rounded-lg
                            bg-black
                            border
                            border-yellow-500/20
                            "

                          />

                        </td>

                        {/* GST */}

                        <td className="p-3">

                          <input

                            type="number"

                            disabled={
                              !!form.invoice_id
                            }

                            value={item.gst_percent}

                            onChange={(e)=>

                              updateItem(

                                index,

                                "gst_percent",

                                e.target.value

                              )

                            }

                            className="
                            w-20
                            p-2
                            rounded-lg
                            bg-black
                            border
                            border-yellow-500/20
                            "

                          />

                        </td>

                        {/* AMOUNT */}

                        <td
                          className="
                          p-3
                          text-center
                          font-semibold
                          "
                        >

                          ₹

                          {

                            (

                              Number(item.qty)

                              *

                              Number(item.price)

                            ).toFixed(2)

                          }

                        </td>

                        {/* REMOVE */}

                        <td className="p-3 text-center">

                          {

                            !form.invoice_id && (

                              <button

                                type="button"

                                onClick={()=>

                                  removeRow(index)

                                }

                                className="
                                text-red-500
                                font-bold
                                "

                              >

                                Remove

                              </button>

                            )

                          }

                        </td>

                      </tr>

                    )

                  )

                }

              </tbody>

            </table>

          </div>

        </div>

                {/* =====================================
            REFUND SUMMARY
        ===================================== */}

        <div
          className="
          mt-10
          bg-[#0d0d0d]
          border
          border-yellow-500/20
          rounded-2xl
          p-6
          "
        >

          <h2
            className="
            text-2xl
            font-bold
            mb-6
            "
          >
            Refund Summary
          </h2>

          <div
            className="
            grid
            md:grid-cols-4
            gap-6
            "
          >

            <div
              className="
              bg-black/40
              rounded-xl
              p-5
              "
            >

              <p className="text-gray-400">
                Subtotal
              </p>

              <h3
                className="
                text-3xl
                font-bold
                mt-3
                "
              >
                ₹
                {subtotal.toFixed(2)}
              </h3>

            </div>

            <div
              className="
              bg-black/40
              rounded-xl
              p-5
              "
            >

              <p className="text-gray-400">
                GST
              </p>

              <h3
                className="
                text-3xl
                font-bold
                mt-3
                text-blue-400
                "
              >
                ₹
                {gstTotal.toFixed(2)}
              </h3>

            </div>

            <div
              className="
              bg-black/40
              rounded-xl
              p-5
              "
            >

              <p className="text-gray-400">
                Refund Type
              </p>

              <h3
                className={`
                text-2xl
                font-bold
                mt-3

                ${
                  refundType === "wallet"

                    ? "text-green-400"

                    : "text-blue-400"

                }
                `}
              >

                {
                  refundType === "wallet"

                    ? "Wallet"

                    : "Adjust Due"

                }

              </h3>

            </div>

            <div
              className="
              bg-yellow-500/10
              border
              border-yellow-500
              rounded-xl
              p-5
              "
            >

              <p className="text-gray-300">
                Total Refund
              </p>

              <h2
                className="
                text-4xl
                font-bold
                text-yellow-400
                mt-3
                "
              >
                ₹
                {grandTotal.toFixed(2)}
              </h2>

            </div>

          </div>

        </div>

        {/* =====================================
            ACTION BUTTONS
        ===================================== */}

        <div
          className="
          flex
          gap-4
          mt-10
          flex-wrap
          "
        >

          <button
            type="submit"
            className="
            bg-yellow-500
            hover:bg-yellow-400
            text-black
            font-bold
            px-8
            py-3
            rounded-xl
            transition
            "
          >
            Save Sales Return
          </button>

          <button
            type="button"
            onClick={() =>
              navigate(
                "/admin/sales-returns"
              )
            }
            className="
            bg-gray-700
            hover:bg-gray-600
            px-8
            py-3
            rounded-xl
            transition
            "
          >
            Cancel
          </button>

        </div>

      </form>

    </div>

  );

}

export default AddSalesReturn;